/* eslint-disable no-nested-ternary */
const Authors = ({ authors, large = false, centreMobile = false, extraMargin = false, alternativeDesign = false }) => {
  if (!authors) return null;

  const authorImageClass = alternativeDesign ? 'w-24 mr-0 rounded-full' : `${large ? 'w-10' : 'w-8'} mr-3 rounded-full`;

  const authorsBlock = authors.map((a, index) => (
    <img
      className={`${authorImageClass} ${index > 0 ? '-ml-4' : ''}`}
      src={a.avatarSrc}
      alt={a.name}
      key={`author-image-${a.name}`}
    />
  ));

  const textBlock = (
    <p className={`line-clamp-4 ${large ? 'text-md' : 'text-xs'} text-gray-900`}>
      <span className="font-medium">{authors.map((a) => a.name).join(' & ')} </span>
      <span className={`text-gray-500 ${alternativeDesign ? 'font-light' : 'font-medium'}`}>
        {authors
          .filter((a) => !!a.title)
          .map((a) => a.title)
          .join(' & ')}
      </span>
    </p>
  );

  return (
    <div className={`${extraMargin ? 'mt-6 mb-8' : 'mt-5'}`}>
      {alternativeDesign ? (
        <>
          <div className={`${centreMobile && 'justify-center'} flex items-center h-24 mb-6`}>{authorsBlock}</div>
          <div className="block text-center">{textBlock}</div>
        </>
      ) : authors.length > 3 ? (
        <>
          <div className={`${centreMobile && 'justify-center md:justify-start'} flex items-center pt-3`}>
            {authorsBlock}
          </div>
          <div className={`${centreMobile && 'justify-center md:justify-start'} flex items-center pt-3`}>
            {textBlock}
          </div>
        </>
      ) : (
        <div className={`${centreMobile && 'justify-center md:justify-start'} flex items-center`}>
          {authorsBlock}
          {textBlock}
        </div>
      )}
    </div>
  );
};

export default Authors;
